<div class="outer-modal">
  <div class="modal-content">
    <div class="modal-body">
      <div style="padding: 10px 10px 0px 10px;">
        <div style="display: flex; justify-content: space-between;">
          {{ title }}
          <button
            style="border: none; background: none"
            (click)="closewindow()"
          >
            <img src="../../assets/images/cross.svg" />
          </button>
        </div>
        <p style="color: #878d96; font-size: 12px; margin: 0;">
          Upload a 1080 x 1080px image for best results
        </p>
      </div>
      <div class="row">
        <div class="col"></div>
        <div>
          <app-inline-loader
            *ngIf="!showCropper"
            class="inline-loader"
          ></app-inline-loader>
        </div>
        <div class="col"></div>
      </div>
      <div style="padding: 5px;" >
        <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="ratio"
          [cropperMinWidth]="200"
          format="png"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()"
          [style.display]="showCropper ? null : 'none'"
        ></image-cropper>
      </div>
      <div class="modal-footer">
        <button
          *ngIf="showCropper"
          class="btn-cancel"
          type="button"
          (click)="closewindow()"
        >
          Cancel
        </button>
        <button
          *ngIf="showCropper"
          class="btn-apply"
          type="button"
          (click)="apply()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
